import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.farm');
import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'wiz-page-admin-farm',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.farm/view.scss */
:host {
  display: block;
}`],
})
export class PageAdminFarmComponent implements OnInit, OnDestroy {

    public type = 'list';
    public farm_id = '';
    public farm: any = null;

    public ready = false;
    private destroy$ = new Subject<void>();

    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) {}

    public async ngOnInit() {
        await this.service.init();

        await this.applyRoute();

        this.ready = true;
        await this.service.render();

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntil(this.destroy$)
        ).subscribe(async () => {
            await this.applyRoute();
            await this.service.render();
        });
    }

    public ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private async applyRoute() {
        const nextType = WizRoute.segment.type || 'list';
        const nextFarmId = WizRoute.segment.farm_id || '';

        const typeChanged = this.type !== nextType;
        const farmChanged = this.farm_id !== nextFarmId;

        this.type = nextType;
        this.farm_id = nextFarmId;

        if (nextType === 'list' || nextType === 'trash') {
            this.farm = null;
            return;
        }

        if (farmChanged) {
            const { code, data } = await wiz.call('farm_info', {
                farm_id: nextFarmId
            });

            this.farm = code === 200 ? data : null;
        }
    }
}

export default PageAdminFarmComponent;